import WalletService from "./wallet";

export default WalletService